let PackagesItem = [
    {
        id: 1,
        trackTitle: "Full Access 🔥",
        trackSubtitle: "for experienced React JS Developers. Deep tech content.",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Senior Track Q&A Sessions',
        trackLink: 'https://geekle.us/ticket/1650372388182x403132784394633200',
    },
    {
        id: 2,
        trackTitle: "Junior Track",
        trackSubtitle: "for React JS Developers",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Junior Track',
        trackLink: 'https://geekle.us/ticketfree/1650379803587x974592585903112200',
    },
];

export default PackagesItem;
